import { createFileRoute } from '@tanstack/react-router'

import { OrganizationEditPage } from '#/modules/organizations/organization-edit-page'

export const Route = createFileRoute('/_shell/organizations/$organizationId_/edit')({
  component: function OrganizationEditRoute() {
    const { organizationId } = Route.useParams()
    return <OrganizationEditPage organizationId={organizationId} />
  },
})
